import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Repeat1 = createReactComponent("Repeat1", ["svg", defaultAttributes, [["path", {
  d: "M17 2l4 4-4 4",
  key: "ij54qh"
}], ["path", {
  d: "M3 11v-1a4 4 0 014-4h14",
  key: "1ymu1p"
}], ["path", {
  d: "M7 22l-4-4 4-4",
  key: "16pa58"
}], ["path", {
  d: "M21 13v1a4 4 0 01-4 4H3",
  key: "1gwnas"
}], ["path", {
  d: "M11 10h1v4",
  key: "ykpro6"
}]]]);
export default Repeat1;